var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"mealSetsModal",attrs:{"id":"mealSetsModal","title":"Wybierz zestaw pół na pół","visible":_vm.visible,"hide-header-close":"","hide-footer":""},on:{"hidden":_vm.hide}},[_c('Meals',{attrs:{"meals":_vm.mealSets,"is-meal-sets":true},on:{"input":_vm.mealSetChosen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }